export function getDisabledDays(disabledDays, disabledDaysOfWeek, min, max) {
    const disabled = [...disabledDays];
    if (disabledDaysOfWeek.length > 0) {
        disabled.push({ dayOfWeek: disabledDaysOfWeek });
    }
    if (min !== undefined) {
        disabled.push({ before: min });
    }
    if (max !== undefined) {
        disabled.push({ after: max });
    }
    return disabled;
}
//# sourceMappingURL=react-day-picker.js.map